import {FlowMode, FormCode} from './types'

/**
 * 育休系手続きの makeFlow で ChildcareMethodSelect を条件 yield するためのゲート情報
 *
 * - `flowMode`: 承認モード（confirm）では方法選択ステップ自体が不要なので skip
 * - `pastChildcareCount`: 当該従業員の過去育休手続き数。0 ならば「過去手続き利用」の選択肢自体が無いので skip
 * - `methodSelectExists`: `procedureTmpDatum(name="childcare_method_select")` が既存か。
 *    既に方法選択済（＝離脱再入）の場合は再度 prompt しないため skip
 */
export interface ChildcareMethodSelectGate {
  flowMode: FlowMode
  pastChildcareCount: number
  methodSelectExists: boolean
}

export function* maybeYieldChildcareMethodSelect(gate: ChildcareMethodSelectGate): Generator<FormCode> {
  if (gate.flowMode === 'confirm') return
  if (gate.pastChildcareCount === 0) return
  if (gate.methodSelectExists) return
  yield 'ChildcareMethodSelect'
}
